//import apiConfig, { ENVIRONMENT_PRODUCTION } from './apiConfig'

// const TYPEFORM_APPLY_URL = 'https://targetteam.tfaforms.net/12'
//const isProd = apiConfig.environment === ENVIRONMENT_PRODUCTION

// Evaluated once at module load time — environment does not change at runtime.
// Enable lead form in prod
export const isPartnerApplicationEnabled = true

const applyProps = { href: '/apply' }

export default applyProps
